module.exports = __webpack_public_path__ + "img/pocket-knief.99ed1ca5.png";